import Vue from "vue";
import axios from "axios";
import { handleError } from "@/utils/errorHandler";
import configuration from "@/utils/configuration";
import { executeAction,executeDownloadAction } from "@/services/api/helpers";
import { courseService } from "@/services/api/features/courseService";

export default {
  namespaced: true,

  state: {
    coursePackages: {},
    options: {},
    packages: [],
    courseType: [],
    categories: [],
    courses: [],
    loading: {},
    error: {},
  },
  getters: {
    allCategories: (state) => state.categories,
    allCourseType: (state) => state.courseType,
    allCourses: (state) => state.courses,
    isLoading: (state) => (action) => !!state.loading[action],
    getError: (state) => (action) => state.error[action],
    coursePackage: (state) => (courseId) => {
      return state.coursePackages[courseId] || null;
    },
  },
  mutations: {
    SET_CATEGORIES(state, categories) {
      state.categories = categories;
    },
    SET_ALL_COURSE(state, courses) {
      state.courses = courses;
    },
    SET_COURSETYPE(state, courseType) {
      state.courseType = courseType;
    },
    SET_PACKAGE(state, packages) {
      state.packages = packages;
    },
    SET_COURSE_PACKAGES(state, { courseId, packages }) {
      Vue.set(state.coursePackages, courseId, packages);
    },
    SET_COURSE_PACKAGE_OPTION(state, { courseId, packageId, payload }) {
      if (!state.coursePackages[courseId]) {
        Vue.set(state.coursePackages, courseId, {});
      }
      Vue.set(state.coursePackages[courseId], packageId, payload);
    },

    SET_COURSES(state, courses) {
      state.courses = courses;
    },
    SET_LOADING(state, { action, status }) {
      state.loading = { ...state.loading, [action]: status };
    },
    SET_ERROR(state, { action, message }) {
      state.error = { ...state.error, [action]: message };
    },
  },
  actions: {

    async getAdminFilteredCourse({ commit }, params) {
      return executeAction({ commit, action: "getAdminFilteredCourse" }, () =>
        courseService.getAdminFilteredCourse(params)
      );
    },
    async getCourseReportList({ commit }) {
      return executeAction({ commit, action: "getCourseReportList" }, () =>
        courseService.getCourseReportList()
      );
    },
    async getAllCategories({ commit }) {
      const action = "getAllCategories";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "GET",
          url: `${configuration.backUrl}/category/management`,
          withCredentials: true,
        });
        commit("SET_CATEGORIES", data.data);
        return data.data;
      } catch (error) {
        handleError(commit, action, error);
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async fetchCategories({ commit }) {
      const action = "fetchCategories";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "GET",
          url: `${configuration.backUrl}/category`,
          withCredentials: true,
        });
        commit("SET_CATEGORIES", data.data);
        return data.data;
      } catch (error) {
        handleError(commit, action, error);
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

    async fetchCategoryById({ commit }, categoryId) {
      const url = `${configuration.backUrl}/category/search?category_id=${categoryId}`;
      const action = "fetchCategoryById";

      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR",{ action, message: null });

      try {
        const response = await fetch(url);

        if (!response.ok)
          throw new Error(`HTTP error! value: ${response.value}`);

        const data = await response.json();

        if (!data.success)
          throw new Error(data.message || "Failed to fetch category");
        return data.data;
      } catch (error) {
        commit("SET_ERROR",{ action, message: error.message });
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async postCategory({ commit }, payload) {
      const action = "postCategory";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "POST",
          url: `${configuration.backUrl}/category`,
          withCredentials: true,
          data: payload,
        });
        return data.data;
      } catch (error) {
        commit("SET_ERROR", {
          action,
          message:
            error.response?.data?.message ||
            error.message ||
            `${action} Failed`,
        });
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async patchCategory({ commit }, { categoryId, payload }) {
      const action = "patchCategory";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "PATCH",
          url: `${configuration.backUrl}/category`,
          withCredentials: true,
          params: { category_id: categoryId },
          data: payload,
        });
        return data.data;
      } catch (error) {
        commit("SET_ERROR", {
          action,
          message:
            error.response?.data?.message ||
            error.message ||
            `${action} Failed`,
        });
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

    async deleteCategory({ commit }, categoryId) {
      const action = "deleteCategory";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "DELETE",
          url: `${configuration.backUrl}/category`,
          withCredentials: true,
          params: { category_id: categoryId },
        });
        return data.data;
      } catch (error) {
        commit("SET_ERROR", {
          action,
          message:
            error.response?.data?.message ||
            error.message ||
            `${action} Failed`,
        });

        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

    // ------------ Couese Management Modules ------------------

    async getAllCourse({ commit }) {
      const action = "getAllCourse";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "GET",
          url: `${configuration.backUrl}/course`,
          params: { limit: 200 },
        });
        commit("SET_ALL_COURSE", data.data);
        return data.data;
      } catch (error) {
        commit("SET_ERROR", {
          action,
          message:
            error.response?.data?.message ||
            error.message ||
            `${action} Failed`,
        });
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

    async fetchCourseType({ commit }) {
      const url = `${configuration.backUrl}/course-type/details`;
      const action = "fetchCourseType";

      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR",{ action, message: null });

      try {
        const response = await fetch(url, { method: "GET" });
        if (!response.ok)
          throw new Error(`HTTP error! value: ${response.value}`);

        const data = await response.json();
        if (!data.success)
          throw new Error(data.message || "Failed to fetch course type");

        commit("SET_COURSETYPE", data.data);
        return data.data;
      } catch (error) {
        commit("SET_ERROR",{ action, message: error.message });
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async fetchCourses({ commit }) {
      const url = `${configuration.backUrl}/course`;
      const action = "fetchCourses";

      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR",{ action, message: null });

      try {
        const response = await fetch(url);

        if (!response.ok) {
          throw new Error(`HTTP error! value: ${response.value}`);
        }

        const data = await response.json();

        if (data.success) {
          commit("SET_ALL_COURSE", data.data);
          return data.data;
        } else {
          commit("SET_ERROR", data.message || "Failed to fetch courses");
        }
      } catch (error) {
        commit("SET_ERROR", error.message || "Network Error");
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

    async fetchShortCourseById({ commit }, courseId) {
      const action = "fetchShortCourseById";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "GET",
          url: `${configuration.backUrl}/course/short-course/details`,
          withCredentials: true,
          params: { course_id: courseId },
        });
        return data.data;
      } catch (error) {
        commit("SET_ERROR", {
          action,
          message:
            error.response?.data?.message ||
            error.message ||
            `${action} Failed`,
        });
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

    async fetchCourseById({ commit }, courseId) {
      const url = `${configuration.backUrl}/course/details?course_id=${courseId}`;
      const action = "fetchCourseById";

      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR",{ action, message: null });

      try {
        const response = await fetch(url);

        if (!response.ok)
          throw new Error(`HTTP error! value: ${response.value}`);

        const data = await response.json();

        if (!data.success)
          throw new Error(data.message || "Failed to fetch course");

        return data.data;
      } catch (error) {
        commit("SET_ERROR",{ action, value: error.message });
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async fetchCourseByType({ commit }, courseTypeId) {
      const url = `${configuration.backUrl}/course-type/courses?course_type_id=${courseTypeId}`;
      const action = "fetchCourseByType";

      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR",{ action, message: null });

      try {
        const response = await fetch(url);

        if (!response.ok)
          throw new Error(`HTTP error! value: ${response.value}`);

        const data = await response.json();

        if (!data.success)
          throw new Error(data.message || "Failed to fetch course by type");

        return data.data;
      } catch (error) {
        commit("SET_ERROR",{ action, value: error.message });
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async getFilterdCourse({ commit }, payload) {
      const action = "getFilterdCourse";

      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR",{ action, message: null });

      try {
        const response = await axios({
          method: "GET",
          url: `${configuration.backUrl}/course/filter`,
          params: payload,
        });

        commit("SET_COURSES", response.data);
        return response.data.data;
      } catch (error) {
        commit("SET_ERROR",{ action, value: error.message });
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async fetchPackages({ commit }) {
      const url = `${configuration.backUrl}/packages`;
      const action = "fetchPackages";

      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR",{ action, message: null });

      try {
        const response = await fetch(url, { method: "GET" });
        if (!response.ok)
          throw new Error(`HTTP error! value: ${response.value}`);

        const data = await response.json();
        if (!data.success)
          throw new Error(data.message || "Failed to fetch packages");

        commit("SET_PACKAGE", data.data);
        return data;
      } catch (error) {
        commit("SET_ERROR",{ action, value: error.message });
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async fetchCourseByCategory({ commit }, categoryId) {
      const url = `${configuration.backUrl}/category/courses?category_id=${categoryId}`;
      const action = "fetchCourseByCategory";

      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR",{ action, message: null });

      try {
        const response = await fetch(url);

        if (!response.ok)
          throw new Error(`HTTP error! value: ${response.value}`);

        const data = await response.json();

        if (!data.success)
          throw new Error(data.message || "Failed to fetch course by category");

        return data.data;
      } catch (error) {
        commit("SET_ERROR",{ action, value: error.message });
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

    async getDayOfWeekOption({ commit }, courseId) {
      const action = "getDayOfWeekOption";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "GET",
          url: `${configuration.backUrl}/course-coach/day-of-week`,
          withCredentials: true,
          params: { course_id: courseId },
        });
        commit("SET_CATEGORIES", data.data);
        return data.data;
      } catch (error) {
        handleError(commit, action, error);
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

    async getStudyTimeOption({ commit }, { courseId, dayOfWeek }) {
      const action = "getStudyTimeOption";

      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR",{ action, message: null });

      try {
        const response = await axios.get(
          `${configuration.backUrl}/course-coach/study-time`,
          {
            params: {
              course_id: courseId,
              day_of_week: dayOfWeek,
            },
            withCredentials: true,
          }
        );
        return response.data.data;
      } catch (error) {
        commit("SET_ERROR",{ action, value: error.message });
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async getCoachOption(
      { commit },
      { courseId, dayOfWeek, startTime, endTime, coursePackageOptionId }
    ) {
      const action = "getCoachOption";

      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR",{ action, message: null });

      try {
        const response = await axios.get(
          `${configuration.backUrl}/course-coach/for-study`,
          {
            params: {
              course_id: courseId,
              day_of_week: dayOfWeek,
              start_time: startTime,
              end_time: endTime,
              course_package_option_id: coursePackageOptionId,
            },
            withCredentials: true,
          }
        );
        return response.data.data;
      } catch (error) {
        commit("SET_ERROR",{ action, value: error.message });
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async getProfileInfo({ commit }, { userId }) {
      const action = "getProfileInfo";

      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR",{ action, message: null });
      try {
        const response = await axios.get(
          `${configuration.backUrl}/course-coach/for-study`,
          {
            params: { user_id: userId },
          }
        );
        return response.data;
      } catch (error) {
        commit("SET_ERROR",{ action, value: error.message });
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

    // CURD Operations for General Course

    async postGeneralCourse({ commit }, payload) {
      const action = "postGeneralCourse";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "POST",
          url: `${configuration.backUrl}/course`,
          headers: { 'Content-Type': 'multipart/form-data' },
          withCredentials: true,
          data: payload,
        });
        return data.data;
      } catch (error) {
        handleError(commit, action, error);
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async patchGeneralCourse({ commit }, { courseId, payload }) {
      const action = "patchGeneralCourse";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "PATCH",
          url: `${configuration.backUrl}/course`,
          withCredentials: true,
          params: { course_id: courseId },
          data: payload,
        });
        return data.data;
      } catch (error) {
        commit("SET_ERROR", {
          action,
          message:
            error.response?.data?.message ||
            error.message ||
            `${action} Failed`,
        });
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    // async deleteCourse({ commit }, courseId) {
    //   const action = "deleteCourse";
    //   commit("SET_LOADING", { action, status: true });
    //   try {
    //     const { data } = await axios({
    //       method: "DELETE",
    //       url: `${configuration.backUrl}/course/management`,
    //       withCredentials: true,
    //       params: { course_id: courseId },
    //     });
    //     return data.data;
    //   } catch (error) {
    //     commit("SET_ERROR", {
    //       action,
    //       message:
    //         error.response?.data?.message ||
    //         error.message ||
    //         `${action} Failed`,
    //     });
    //     throw error;
    //   } finally {
    //     commit("SET_LOADING", { action, status: false });
    //   }
    // },
    async patchCategoryStatus({ commit }, { categoryId, value }) {
      const action = "patchCategoryStatus";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "PATCH",
          url: `${configuration.backUrl}/category/update-value`,
          withCredentials: true,
          params: {
            category_id: categoryId,
            is_active: value,
          },
        });
        return data.data;
      } catch (error) {
        commit("SET_ERROR", {
          action,
          message:
            error.response?.data?.message ||
            error.message ||
            `${action} Failed`,
        });
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

    async patchCourseStatus({ commit }, { courseId, status }) {
      const action = "patchCourseStatus";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "PATCH",
          url: `${configuration.backUrl}/course/update-status`,
          withCredentials: true,
          params: {
            course_id: courseId,
            status,
          },
        });
        return data.data;
      } catch (error) {
        handleError(commit, action, error);
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    // CURD Operations for Short Course

    async patchShortCourse({ commit }, { courseId, payload }) {
      const action = "patchShortCourse";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "PATCH",
          url: `${configuration.backUrl}/course/short-course`,
          withCredentials: true,
          params: { course_id: courseId },
          data: payload,
        });
        return data.data;
      } catch (error) {
        handleError(commit, action, error);
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

    //CURD Course Coach
    async getCourseCoachById({ commit }, courseCoachId) {
      const action = "postCourseCoachById";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "GET",
          url: `${configuration.backUrl}/course-coach`,
          withCredentials: true,
          params: { course_coach_id: courseCoachId },
        });
        return data.data;
      } catch (error) {
        handleError(commit, action, error);
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

    async getCourseCoachByCourseId({ commit }, courseId) {
      const action = "getCourseCoachByCourseId";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "GET",
          url: `${configuration.backUrl}/course-coach/course`,
          withCredentials: true,
          params: { course_id: courseId },
        });
        return data.data;
      } catch (error) {
        handleError(commit, action, error);
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

    async postCourseCoach({ commit }, payload) {
      const action = "postCourseCoach";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "POST",
          url: `${configuration.backUrl}/course-coach`,
          withCredentials: true,
          data: payload,
        });
        return data.data;
      } catch (error) {
        handleError(commit, action, error);
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async patchCourseCoach({ commit }, { courseCoachId, payload }) {
      const action = "patchCourseCoach";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "PATCH",
          url: `${configuration.backUrl}/course-coach`,
          withCredentials: true,
          params: { course_coach_id: courseCoachId },
          data: payload,
        });
        return data.data;
      } catch (error) {
        commit("SET_ERROR", {
          action,
          message:
            error.response?.data?.message ||
            error.message ||
            `${action} Failed`,
        });
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async deleteCourseCoach({ commit }, courseCoachId) {
      const action = "deleteCourseCoach";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "DELETE",
          url: `${configuration.backUrl}/course-coach`,
          withCredentials: true,
          params: { course_coach_id: courseCoachId },
        });
        return data.data;
      } catch (error) {
        commit("SET_ERROR", {
          action,
          message:
            error.response?.data?.message ||
            error.message ||
            `${action} Failed`,
        });
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

    //CURD Course Package Option

    async fetchCoursePackage({ commit }, courseId) {
      const action = "fetchCoursePackage";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "GET",
          url: `${configuration.backUrl}/course/course-package-option`,
          withCredentials: true,
          params: { course_id: courseId },
        });

        return data.data;
      } catch (error) {
        handleError(commit, action, error);
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async getPackageOptionByCourseId({ commit }, courseId) {
      const action = "getPackageOptionByCourseId";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "GET",
          url: `${configuration.backUrl}/course/packages/course-package-options`,
          withCredentials: true,
          params: { course_id: courseId },
        });
        return data.data;
      } catch (error) {
        handleError(commit, action, error);
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async fetchCoursePackageOption({ commit }, { courseId, packageId }) {
      const action = "fetchCoursePackageOption";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "GET",
          url: `${configuration.backUrl}/packages/details`,
          withCredentials: true,
          params: {
            course_id: courseId,
            package_id: packageId,
          },
        });
        return data.data;
      } catch (error) {
        handleError(commit, action, error);
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

    async fetchCoursePackageAndOption({ commit }, courseId) {
      const action = "fetchCoursePackageAndOption";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "GET",
          url: `${configuration.backUrl}/course/package-option`,
          withCredentials: true,
          params: {
            course_id: courseId,
          },
        });
        return data.data;
      } catch (error) {
        handleError(commit, action, error);
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

    async postPackageOption({ commit }, payload) {
      const action = "postPackageOption";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "POST",
          url: `${configuration.backUrl}/course/package-option`,
          withCredentials: true,
          data: payload,
        });
        return data.data;
      } catch (error) {
        handleError(commit, action, error);
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async patchPackageOption({ commit }, { coursePackageOptionId, payload }) {
      const action = "patchPackageOption";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "PATCH",
          url: `${configuration.backUrl}/course/management/general-course/package-option`,
          withCredentials: true,
          params: { course_package_option_id: coursePackageOptionId },
          data: payload,
        });
        return data.data;
      } catch (error) {
        handleError(commit, action, error);
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async deletePackageOption({ commit }, coursePackageOption) {
      const action = "deletePackageOption";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "DELETE",
          url: `${configuration.backUrl}/course/package-option`,
          withCredentials: true,
          params: { course_package_option_id: coursePackageOption },
        });
        return data.data;
      } catch (error) {
        handleError(commit, action, error);
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async deleteCoursepackage({ commit }, { courseId, packageId }) {
      const action = "deleteCoursepackage";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "DELETE",
          url: `${configuration.backUrl}/course/package`,
          withCredentials: true,
          params: { course_id: courseId, package_id: packageId },
        });
        return data.data;
      } catch (error) {
        handleError(commit, action, error);
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

    // --------------  FOR ADMIN ------------------

    async getShortCourseDetail({ commit }, courseId) {
      const action = "getShortCourseDetail";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "GET",
          url: `${configuration.backUrl}/course/management/short-course/detail`,
          withCredentials: true,
          params: { course_id: courseId },
        });
        return data.data;
      } catch (error) {
        handleError(commit, action, error);
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async postShortCourse({ commit }, payload) {
      const action = "postShortCourse";
      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR", { action, message: null });
      try {
        const { data } = await axios({
          method: "POST",
          url: `${configuration.backUrl}/course/short-course`,
          withCredentials: true,
          headers: { 'Content-Type': 'multipart/form-data' },
          data: payload,
        });
        return data.data;
      } catch (error) {
        handleError(commit, action, error);
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async manageCoursePackageOption({ commit }, payload) {
      const action = "manageCoursePackageOption";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "POST",
          url: `${configuration.backUrl}/course/package-option/management/operations`,
          withCredentials: true,
          data: payload,
        });
        return data.data;
      } catch (error) {
        handleError(commit, action, error);
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async getCourseFilterList({ commit }) {
      const action = "getCourseFilterList";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "GET",
          url: `${configuration.backUrl}/course/filter-options`,
          withCredentials: true,
        });
        return data.data;
      } catch (error) {
        handleError(commit, action, error);
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    //  New
    async getUserCourseEvaluation({ commit }, params) {
      const action = "getUserCourseEvaluation";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "GET",
          url: `${configuration.backUrl}/assessments`,
          withCredentials: true,
          params: params,
        });
        return data.data;
      } catch (error) {
        handleError(commit, action, error);
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

    async getUserClassEvaluation({ commit }, params) {
      const action = "getUserClassEvaluation";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "GET",
          url: `${configuration.backUrl}/course/schedule/assessment/search`,
          withCredentials: true,
          params: params,
        });
        return data.data;
      } catch (error) {
        handleError(commit, action, error);
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async getStudentViewFilter({ commit }, courseId) {
      return executeAction({ commit, action: "getStudentViewFilter" }, () =>
        courseService.getStudentViewFilter(courseId)
      );
    },
    async patchConfirmReserve({ commit }, params) {
      return executeAction({ commit, action: "patchConfirmReserve" }, () =>
        courseService.patchConfirmReserve(params)
      );
    },
    async getclassViewFilter({ commit }, courseId) {
      return executeAction({ commit, action: "getclassViewFilter" }, () =>
        courseService.getclassViewFilter(courseId)
      );
    },
    async getExportReserveStudent({ commit }, params) {
      return await executeDownloadAction(
        { commit, action: "getExportReserveStudent" },
        () => courseService.getExportReserveStudent(params),
        "Student_Course_Reservations.xls"
      );
    },
    async getExportrCompleteStudent({ commit }, params) {
      return await executeDownloadAction(
        { commit, action: "getExportrCompleteStudent" },
        () => courseService.getExportrCompleteStudent(params),
        "Completed_Students.xls"
      );
    },
    async getExportCurrentStudent({ commit }, payload) {
      return await executeDownloadAction(
        { commit, action: "getExportCurrentStudent" },
        () => courseService.getExportCurrentStudent(payload),
        "Active_Students_Report.xls"
      );
    },

async deleteCourse({ commit },courseId) {
      return executeAction({ commit, action: "deleteCourse" }, () =>
        courseService.deleteCourse(courseId)
      );
    },
    // Image & file management
    async patchCourseImg({ commit }, { courseId, payload }) {
      return executeAction({ commit, action: "patchCourseImg" }, () =>
        courseService.patchCourseImg(courseId, payload)
      );
    },
    async deleteCourseImg({ commit }, courseId) {
      return executeAction({ commit, action: "deleteCourseImg" }, () =>
        courseService.deleteCourseImg(courseId)
      );
    },
    async patchPrivilageImg({ commit }, { courseId, payload }) {
      return executeAction({ commit, action: "patchPrivilageImg" }, () =>
        courseService.patchPrivilageImg(courseId, payload)
      );
    },
    async deletePrivilageImg({ commit }, courseId) {
      return executeAction({ commit, action: "deletePrivilageImg" }, () =>
        courseService.deletePrivilageImg(courseId)
      );
    },
    async patchJourneyImg({ commit },{courseId,payload}) {
      return executeAction({ commit, action: "patchJourneyImg" }, () =>
        courseService.patchJourneyImg(courseId,payload)
      );
    },
    async deleteJourneyImg({ commit }, learningJourneyId) {
      return executeAction({ commit, action: "deleteJourneyImg" }, () =>
        courseService.deleteJourneyImg(learningJourneyId)
      );
    },
    async getJourneyImg({ commit }, courseId) {
      return executeAction({ commit, action: "getJourneyImg" }, () =>
        courseService.getJourneyImg(courseId)
      );
    },
  },
};
